export default __webpack_public_path__ + "static/media/image-work-team-m.7758b2b4.webp";